<div class="color-blue">
  {{ 'screening.screening_overrides.export.company_information.company_legal_right_title' | translate }}
</div>
@if (companyLegalRightComposites$ | async; as companyLegalRightComposites) {
  <table>
    <tbody>
      @if (persons$ | async; as persons) {
        @for (composite of companyLegalRightComposites; track composite.company_legal_right.uuid) {
          <tr>
            <td class="width-50">
              <nk-date-range
                [dates]="{
                  fromDate: composite.company_legal_right.from_date,
                  toDate: composite.company_legal_right.to_date,
                }"></nk-date-range>
            </td>
            <td>
              <span [innerHTML]="composite.company_legal_right.legal_right_text | textToPersonLinkPipe: persons"></span>
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
} @else {
  {{ 'common.no_data' | translate }}
}
